import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Form, Input, Select, Switch, Button, Space, notification } from 'antd';
import { InfoCircleOutlined, LeftCircleOutlined, CheckOutlined, CloseOutlined, StopOutlined } from '@ant-design/icons';

import languageManager from '../../../services/languageManager';
import * as storeActions from './store/actions/specifics';

import Loader from '../../common/PageElements/Loader';
import PageHeader from '../../common/PageElements/PageHeader'

class SpecificsEdit extends Component {

   state = {
      action: undefined,
      itemId: undefined,
      saveAndClose: false,
      pageLoader: true,
      formValues: {},
      marketplacesList: [],
      componentLanguage: this.props.authState.defaultLanguage
   };

   // static getDerivedStateFromProps(props, state) {
   //    if (props.action === 'edit') {
   //       const formValues = {
   //          id: props.itemData.id,
   //          name: props.itemData.name.it,
   //          percentage: props.itemData.percentage,
   //          language: 'it'
   //       }
   //       return updateObject(state, { formValues: formValues });
   //       // state.initial_values.name = props.itemData.t_name;
   //       // state.initial_values.percentage = props.itemData.percentage;
   //    }

   //    return state;
   // }

   setForm = (response_data) => {
      const values = {
         ...response_data,
         name: response_data.name[this.state.componentLanguage],
         description: !_.isNil(response_data.description) ? response_data.description[this.state.componentLanguage] : '',
         is_active: response_data.active,
         language: this.state.componentLanguage,
         attribute_type_id: 1,
      }
      return values;
   }

   getItem = (id) => {
      return storeActions.getItem(id)
         .then(response => {
            console.log(response);
            try {
               const updatedValues = this.setForm(response.data);
               this.setState({ formValues: updatedValues });

            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   getComplements = () => {
      return storeActions.getSpecificComplements()
         .then(response => {
            console.log(response);
            try {
               this.setState({
                  marketplacesList: response.marketplacesList,
               });

            } catch (e) {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   componentDidMount() {
      if (this.props.match.params.id) {
         const itemId = this.props.match.params.id
         Promise.all([
            this.getItem(itemId),
            this.getComplements()
         ]).then(() => {
            this.setState({
               action: 'edit',
               itemId: itemId,
               pageLoader: false
            });
         });
      }
      else {
         const formValues = {
            is_active: false,
            language: this.state.componentLanguage,
            attribute_type_id: 1,
         }
         Promise.all([
            this.getComplements()
         ]).then(() => {
            this.setState({
               formValues: formValues,
               action: 'insert',
               pageLoader: false
            });
         });
      }

   }

   handleSaveAndClose = () => {
      this.setState({ saveAndClose: true });
      console.log(this.state);
   }

   onFinish = values => {
      this.setState({ saveLoader: true });
      values.id = this.state.itemId
      storeActions.createOrUpdate(values)
         .then(response => {
            this.setState({ saveLoader: false });
            console.log(response);
            try {
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.confirm.title'),
                  description: languageManager.getMessage(this.props.commonState, this.state.action === 'edit' ? 'notification.confirm.updateOk' : 'notification.confirm.insertOk'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
               if (this.state.saveAndClose) {
                  this.props.history.push('/specifics/list');
               } else {
                  const updatedValues = this.setForm(response.data);
                  this.setState({ itemId: response.data.id, action: 'edit', formValues: updatedValues, saveLoader: false });
               }

            } catch (e) {
               this.setState({ saveLoader: false });
               notification.open({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
                  icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
               })
            }

         }).catch((e) => {
            this.setState({ saveLoader: false });
            notification.open({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
            })
         });
   };

   onFinishFailed = errorInfo => {
      notification.open({
         message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
         description: languageManager.getMessage(this.props.commonState, 'notification.error.formInvalid'),
         icon: <InfoCircleOutlined style={{ color: '#108ee9' }} />,
      })
   };

   onActiveSwitchChange = (checked) => {
      let newFormValues = { ...this.state.formValues }
      newFormValues.is_active = checked;
      this.setState({ formValues: newFormValues });
   }

   // onReset = () => {
   //   form.resetFields();
   // };

   render() {
      if (!this.props.authState.userData.languages) return '';
      const { TextArea } = Input;
      const { Option } = Select;

      const layout = {
         labelCol: { span: 8 },
         wrapperCol: { span: 16 },
      };
      const tailLayout = {
         wrapperCol: { offset: 8, span: 16 },
      };

      let form = (
         <Form
            {...layout}
            id="createSpecific"
            name="basic"
            initialValues={this.state.formValues}
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
         >
            <Form.Item
               label="Nome"
               name="name"
               rules={[{ required: true, message: 'Inserisci il nome' }]}
            >
               <Input />
            </Form.Item>
            <Form.Item
               label="Descrizione"
               name="description"
               rules={[{ message: 'Descrizione estesa' }]}
            >
               <TextArea rows={4} />
            </Form.Item>

            {
               this.state.marketplacesList.map((marketplace) => {
                  return (
                     <Form.Item
                        key={marketplace.id}
                        label={marketplace.name}
                     >
                        <Input.Group compact>
                           <Form.Item
                              name={'marketplace_active_' + marketplace.id}
                              valuePropName="checked"
                           >
                              <Switch
                                 checkedChildren={<CheckOutlined />}
                                 unCheckedChildren={<StopOutlined />}
                                 defaultChecked
                              />
                           </Form.Item>
                           <Form.Item
                              name={'marketplace_value_' + marketplace.id}
                           >
                              <Input style={{ marginLeft: '15px', width: '300px' }} placeholder='Valore sul marketplace' />
                           </Form.Item>
                        </Input.Group>
                     </Form.Item>
                  )
               })
            }

            <Form.Item label="language" name="language" noStyle><Input type="hidden" /></Form.Item>
            <Form.Item label="attribute_type_id" name="attribute_type_id" noStyle><Input type="hidden" /></Form.Item>

         </Form>
      );


      const pageContent = (
         <div className="card">
            <div className="card-header">
               <div className="align-items-center row">
                  <div className="col-sm-6">{languageManager.getMessage(this.props.commonState, 'component.specifics.title')}</div>
                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">
                        <Space>
                           <Select
                              showSearch
                              className="width-70px-I"
                              placeholder="Seleziona la lingua"
                              defaultValue={this.state.componentLanguage.toUpperCase()}
                              optionFilterProp="children"
                              onChange={this.setDefaultLanguageHandler}
                           //  onFocus={onFocus}
                           //  onBlur={onBlur}
                           //  onSearch={onSearch}
                           //  filterOption={(input, option) =>
                           //    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                           //  }
                           >
                              {
                                 this.props.authState.userData.languages.map((lang) => {
                                    return <Option key={lang.value} value={lang.value}>{lang.label}</Option>
                                 })
                              }
                           </Select>
                        </Space>
                     </div>
                  </div>
               </div>
            </div>
            <div className="card-body">
               {this.state.pageLoader ? <Loader /> : form}
            </div>
            <div className="card-footer">
               <div className="align-items-center row">
                  <div className="col-sm-6">
                     <Space>
                        <Button
                           size='large'
                           onClick={() => { this.props.history.goBack() }}
                        >
                           <i className="mdi mdi-arrow-left-drop-circle-outline mr-1"></i>
                           {languageManager.getMessage(this.props.commonState, 'common.back')}
                        </Button>
                     </Space>
                  </div>

                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">

                        <Space>
                           <Button form="createSpecific" htmlType="button" loading={this.state.saveLoader}>Annulla</Button>
                           <Button form="createSpecific" type="primary" htmlType="submit" loading={this.state.saveLoader}>Salva</Button>
                           <Button form="createSpecific" type="primary" htmlType="submit" onClick={this.handleSaveAndClose} loading={this.state.saveLoader}>Salva e chiudi</Button>
                        </Space>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      );

      return (
         <div className="container-fluid">
            <div className="row">
               <div className="col">
                  {pageContent}
               </div>
            </div>
         </div>

      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState
   };
};

// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(SpecificsEdit);